import { render, staticRenderFns } from "./SdataTimePreview.vue?vue&type=template&id=dbffc1d8&"
import script from "./SdataTimePreview.vue?vue&type=script&lang=js&"
export * from "./SdataTimePreview.vue?vue&type=script&lang=js&"
import style0 from "./SdataTimePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports